/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WearGlobal
 */
export interface WearGlobal {
    /**
     * 
     * @type {number}
     * @memberof WearGlobal
     */
    fw0CntDrvParkBr: number;
    /**
     * 
     * @type {number}
     * @memberof WearGlobal
     */
    fw0VMaxDrvParkBr: number;
}

export function WearGlobalFromJSON(json: any): WearGlobal {
    return WearGlobalFromJSONTyped(json, false);
}

export function WearGlobalFromJSONTyped(json: any, ignoreDiscriminator: boolean): WearGlobal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fw0CntDrvParkBr': json['fw0_cnt_drv_park_br'],
        'fw0VMaxDrvParkBr': json['fw0_v_max_drv_park_br'],
    };
}

export function WearGlobalToJSON(value?: WearGlobal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fw0_cnt_drv_park_br': value.fw0CntDrvParkBr,
        'fw0_v_max_drv_park_br': value.fw0VMaxDrvParkBr,
    };
}


